;(function (module) {
  'use strict'
  module.controller('passwordController', [
    '$scope',
    '$http',
    '$state',
    'ngDialog',
    'authService',
    'members',
    function ($scope, $http, $state, ngDialog, authService, members) {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/
      var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/
      $scope.user = {}
      $scope.validate = {
        //'valid', 'invalid', 'not-validated'
        emailValidity: 'not-validated',
        passwordValidity: 'not-validated',
        confirmValidity: 'not-validated',
      }

      //Change user password
      $scope.changePassword = function () {
        var isPasswordValid = passwordRegex.test($scope.user.password)
        if (!isPasswordValid) {
          $scope.validate.passwordValidity = 'invalid'
        }

        if ($scope.user.password !== $scope.user.confirm) {
          $scope.validate.confirmValidity = 'invalid'
        }

        var passwordInvalid = $scope.validate.passwordValidity === 'invalid',
          confirmInvalid = $scope.validate.confirmValidity === 'invalid'

        if (passwordInvalid || confirmInvalid) {
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: [
              '$scope',
              function ($scope) {
                $scope.errMsg = ''
                if (passwordInvalid) {
                  $scope.errMsg +=
                    '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>'
                }
                if (confirmInvalid) {
                  $scope.errMsg +=
                    '<p>Password and Confirm Password fields do not match.</p>'
                }
                $scope.errTitle = 'Error'
              },
            ],
          })
          dialog.closePromise.then(function (data) {})
        } else {
          $scope.ajaxload = true
          let member = authService.getLoginMember()
          member.Password = $scope.user.password
          members.changePassword(member.Id, member).then(
            function (result) {
              member.Password = null
              $scope.ajaxload = false

              // Clean form after successful submission
              $scope.user.password = $scope.user.confirm = null
              $scope.validate.passwordValidity = $scope.validate.confirmValidity =
                'not-validated'
              var dialog = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.successMsg =
                      'Your password was successfully changed.'
                    $scope.strTitle = 'Password Changed'
                  },
                ],
              })
              dialog.closePromise.then(function (data) {})
            },
            function (error) {
              member.Password = null
              $scope.ajaxload = false
              console.log(error)
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.errMsg = `<p>You have made an invalid request. Please try again.</p>`
                    $scope.errTitle = 'Error'
                  },
                ],
              })
              dialog.closePromise.then(function (data) {})
            },
          )
        }
      }

      $scope.forgot = async function () {
        var isEmailValid = emailRegex.test($scope.user.email)

        if (!isEmailValid) {
          var dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: [
              '$scope',
              function ($scope) {
                $scope.errMsg = `<p>Email address is invalid.</p>`
                $scope.errTitle = 'Error'
              },
            ],
          })
          dialog.closePromise.then( function (data) {})
        } else {  
          var email = $scope.user.email
          const memberInfo = await $http.get('/getMemberInfo/'+ email);
          if(!memberInfo.data.AllowAgentAccess && !memberInfo.data.IsAdmin){
              $scope.ajaxload = false
              var dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.errMsg = `<p> You are not authorized. This is only for agents. </p>`
                    $scope.errTitle = 'Reset Password Error'
                  },
                ],
              })
              dialog.closePromise.then(function (data) {
                if (isMobile.any()) {
                  $state.go('closepage')
                } else {
                  $state.go('login')
                }
              })
          }else{
              $scope.ajaxload = true
              authService.forgotPassword($scope.user.email).then(
                (result) => {
                  $scope.ajaxload = false
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.strTitle = 'Password Reset Status'
                        $scope.successMsg = result.data
                      },
                    ],
                  })
                  dialog.closePromise.then(function (data) {
                    if (isMobile.any()) {
                      $state.go('closepage')
                    } else {
                      $state.go('login')
                    }
                  })
                },
                (error) => {
                  $scope.ajaxload = false
                  var dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.errMsg = `<p> ${error.data}</p>`
                        $scope.errTitle = 'Reset Password Error'
                      },
                    ],
                  })
                  dialog.closePromise.then(function (data) {
                    if (isMobile.any()) {
                      $state.go('closepage')
                    } else {
                      $state.go('login')
                    }
                  })
                },
              )
            }
        }
      }

      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i)
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i)
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i)
        },
        Windows: function () {
          return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
          )
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          )
        },
      }
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/passwordController.js